import {Component} from '@angular/core';

@Component({
    selector: 'dk-harmonogram-details',
    template: require('./harmonogram-details.html'),
    entryComponents: [],
    inputs: ['harmonogram']
})

export class HarmonogramDetailsComponent {
    harmonogram: any;
}
